import type { MouseEventHandler } from 'react';
import styled from 'styled-components';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import type { WheelRewardType } from '../wheel';
import { Button } from './button';
import { ContentContainer, Decline, Disclaimer } from './content';
import { Form } from './form/form';
import { Title } from './title';

interface ContentProps {
  closePopup: () => void;
  spin: () => void;
  winningReward?: WheelRewardType;
  className?: string;
  isMobile?: boolean;
}

export const InitContent = ({
  className,
  closePopup,
  spin,
  isMobile
}: ContentProps) => {
  const {
    headerTitle,
    headerCaption,
    textColor,
    accentColor,
    footerText,
    emailRequiredToSpin
  } = useSettings();

  const { t } = useLingui();
  const buttonText = t`Spin Now`;

  const clickHandler: MouseEventHandler = () => {
    spin();
  };

  return (
    <ContentContainer className={className}>
      <Title
        title={headerTitle}
        caption={headerCaption}
        isMobile={isMobile}
        textColor={textColor}
      />
      <FormContainer>
        {emailRequiredToSpin && <Form spin={spin} isMobile={isMobile} />}
        {buttonText && (
          <Button
            onClick={clickHandler}
            buttonText={buttonText}
            isMobile={isMobile}
            accentColor={accentColor}
          />
        )}
      </FormContainer>
      <Decline
        onClick={closePopup}
        _fontSize={isMobile ? 16 : 18}
        _color={textColor}
      >
        {t`No, Thank you`}
      </Decline>
      {footerText && (
        <Disclaimer
          dangerouslySetInnerHTML={{ __html: footerText }}
          _color={textColor}
        />
      )}
    </ContentContainer>
  );
};

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
